import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const CheckedIconOrgSelect = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      {/* <g className="nc-icon-wrapper">
        <path
          id="Check"
          className="cls-1"
          d="M467.393 1606.55a1.468 1.468 0 0 0-2.1 0l-14.8 14.83-8.856-8.88a1.489 1.489 0 1 0-2.1 2.11l9.906 9.93a1.474 1.474 0 0 0 2.1 0l15.85-15.89a1.483 1.483 0 0 0 0-2.1z"
          transform="translate(-439.125 -1606.12)"
          fillRule="evenodd"
        />
      </g> */}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00016 16.17L4.83016 12L3.41016 13.41L9.00016 19L21.0002 7L19.5902 5.59L9.00016 16.17Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(CheckedIconOrgSelect);
